// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadPanel/components/UploadItem/index.css
// module id = 2300
// module chunks = 0